import styled from "styled-components";

interface ButtonProps {
	expanded?: boolean;
	side?: "left" | "right" | "center";
	vertical?: "top" | "bottom";
}

export const Button = styled.div<ButtonProps>`
	position: absolute;
	font-size: 1rem;
	${({ side = "right" }) =>
		side === "right"
			? "right: 2%;"
			: side === "left"
			? "left: 2%;"
			: "left: 50%; transform: translateX(-50%);"}
	${({ vertical = "bottom" }) =>
		vertical === "bottom" ? "bottom: 2%;" : "top: 2%;"}
	width: fit-content;
	background: rgb(179, 0, 255);
	color: #fff;
	border-radius: 0.7em;
	padding: 0.35em 0.4em;
	font-weight: 700;
	cursor: pointer;
	text-align: center;
	white-space: nowrap;
	user-select: none;
	touch-action: none;
	overflow: ${({ expanded }) => (expanded ? "auto" : "hidden")};
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	max-width: ${({ expanded }) => (expanded ? "92%" : "auto")};
	transition: max-width 0.3s ease, font-size 0.15s ease;
`;
